// extracted by mini-css-extract-plugin
export default {"backdrop":"modal_backdrop__h3oy4","modal":"modal_modal__GNo2X","slide-down":"modal_slide-down__TppKd"};